// extracted by mini-css-extract-plugin
export default {"button":"ClaimButton_button__yVfS4","disabled":"ClaimButton_disabled__oPMKG","label":"ClaimButton_label__ytGOM","amount":"ClaimButton_amount__F+SoJ"};